{
  "fontBase": {
    "family": "Inter, -apple-system, 'Helvetica Neue', 'Segoe UI', Roboto, Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
    "size": {
      "xs": "14px",
      "sm": "15px",
      "md": "15px",
      "lg": "16px",
      "xl": "16px"
    },
    "lineHeight": "1.5"
  },
  "font": {
    "display10": {
      "size": "Min(8rem, 20vw)",
      "lineHeight": "1.05"
    },
    "display20": {
      "size": "Min(6.25rem, 16vw)",
      "lineHeight": "1.15"
    },
    "display30": {
      "size": "Min(4.5rem, 11.5vw)",
      "lineHeight": "1.25"
    },
    "display40": {
      "size": "Min(2.75rem, 7vw)",
      "lineHeight": "1.35"
    },
    "heading10": {
      "size": "Min(2.5rem, 6.4vw)",
      "lineHeight": "1.45"
    },
    "heading20": {
      "size": "2.25rem",
      "lineHeight": "1.55"
    },
    "heading30": {
      "size": "1.875rem",
      "lineHeight": "1.65"
    },
    "heading40": {
      "size": "1.5rem",
      "lineHeight": "1.75"
    },
    "paragraph10": {
      "size": "1.125rem",
      "lineHeight": "1.85"
    },
    "paragraph20": {
      "size": "1rem",
      "lineHeight": "1.95"
    },
    "paragraph30": {
      "size": "0.9rem",
      "lineHeight": "2.05"
    },
    "paragraph40": {
      "size": "0.8rem",
      "lineHeight": "2.15"
    },
    "paragraph50": {
      "size": "0.7rem",
      "lineHeight": "2.25"
    }
  },
  "grid": {
    "default": {
      "columns": 12,
      "size": "1fr",
      "columnGap": {
        "xs": "Max(4vw, Min(96px, calc(100% / 24)))",
        "sm": "Max(4vw, Min(96px, calc(100% / 24)))",
        "md": "Max(4vw, Min(96px, calc(100% / 24)))",
        "lg": "Max(4vw, Min(96px, calc(100% / 24)))",
        "xl": "Max(4vw, Min(96px, calc(100% / 24)))"
      },
      "rowGap": {
        "xs": "0",
        "sm": "0",
        "md": "0",
        "lg": "0",
        "xl": "0"
      }
    }
  },
  "mediaQuery": {
    "xs": "0",
    "sm": "768px",
    "md": "1024px",
    "lg": "1440px",
    "xl": "1600px"
  },
  "container": {
    "default": {
      "maxWidth": {
        "xs": "calc(100% - var(--grid-default-column-gap-xs) * 2)",
        "sm": "calc(100% - var(--grid-default-column-gap-sm) * 2)",
        "md": "calc(1024px - var(--grid-default-column-gap-md) * 2)",
        "lg": "calc(1440px - var(--grid-default-column-gap-lg) * 2)",
        "xl": "calc(1600px - var(--grid-default-column-gap-xl) * 2)"
      }
    },
    "fluid": {
      "maxWidth": {
        "xs": "calc(100% - var(--grid-default-column-gap-xs) * 2)",
        "sm": "calc(100% - var(--grid-default-column-gap-sm) * 2)",
        "md": "calc(100% - var(--grid-default-column-gap-md) * 2)",
        "lg": "calc(100% - var(--grid-default-column-gap-lg) * 2)",
        "xl": "calc(100% - var(--grid-default-column-gap-xl) * 2)"
      }
    }
  },
  "button": {
    "size": {
      "xs": "0.7rem",
      "sm": "0.8rem",
      "md": "1rem",
      "lg": "1.25rem",
      "xl": "1.45rem"
    },
    "borderRadius": "0.2em"
  },
  "form": {
    "default": {
      "backgroundColor": "var(--color-neutral-100)",
      "backgroundColorDisabled": "var(--color-neutral-200)",
      "backgroundColorInfo": "var(--color-warning-100)",
      "backgroundColorError": "var(--color-warning-100)",
      "color": "var(--color-neutral-800)",
      "colorPlaceholder": "var(--color-neutral-400)",
      "colorHover": "var(--color-neutral-900)",
      "colorDisabled": "var(--color-neutral-700)",
      "colorInfo": "var(--color-warning-900)",
      "colorError": "var(--color-warning-900)",
      "border": "0 solid transparent",
      "borderWidth": "2px",
      "borderColor": "var(--color-neutral-200)",
      "borderColorHover": "var(--color-neutral-300)",
      "borderColorDisabled": "var(--color-neutral-300)",
      "borderColorInfo": "var(--color-warning-500)",
      "borderColorError": "var(--color-warning-500)",
      "borderRadius": "var(--border-radius)",
      "outline": "3px solid transparent",
      "outlineColorFocus": "var(--color-neutral-800)",
      "outlineColorActive": "var(--color-primary-500)",
      "outlineColorError": "var(--color-warning-500)",
      "outlineOffset": "0",
      "transition": "border 150ms ease-in 0s, outline-color 150ms ease-in 0s, color 200ms ease-out 0s, box-shadow 200ms ease 0s",
      "field": {
        "gap": "0.5rem"
      },
      "control": {
        "padding": "0.8em",
        "fontSize": "1rem",
        "fontWeight": "inherit",
        "lineHeight": "1.625"
      },
      "label": {
        "padding": "0",
        "fontSize": "0.9rem",
        "fontWeight": "500",
        "lineHeight": "1.2"
      },
      "error": {
        "margin": "0.5em 0",
        "padding": "0.2em 0.4em",
        "fontSize": "0.9rem",
        "fontWeight": "500",
        "lineHeight": "1.2",
        "border": "1px solid var(--form-border-color-error)",
        "backgroundColor": "var(--form-background-color-error)",
        "color": "var(--form-color-error)"
      }
    },
    "minimal": {
      "borderWidth": "0 0 2px 0",
      "borderRadius": "0",
      "outlineOffset": "0"
    }
  },
  "card": {
    "shadow": "0 20px 20px -10px rgba(0,0,0,0.2)"
  },
  "backdrop": {
    "opacity": 0.5
  },
  "border": {
    "radius": "0.35em"
  },
  "shadow": {
    "xs": "0 0.1rem 0.4rem -0.1rem rgba(0, 0, 0, 0.2)",
    "sm": "0 0.3rem 0.8rem -0.2rem rgba(0, 0, 0, 0.3)",
    "md": "0 0.6rem 1.6rem -0.3rem rgba(0, 0, 0, 0.4)",
    "lg": "0 0.9rem 3.2rem -0.4rem rgba(0, 0, 0, 0.5)",
    "xl": "0 1.2rem 6.4rem -0.5rem rgba(0, 0, 0, 0.6)"
  },
  "transition": {
    "smooth": "400ms cubic-bezier(0.73, 0.01, 0.24, 1)"
  },
  "color": {
    "neutral": {
      "100": "#FFFFFF",
      "200": "#EFEFF2",
      "300": "#DBDBD7",
      "400": "#B1B1B1",
      "500": "#7E7E8B",
      "600": "#61616B",
      "700": "#44444B",
      "800": "#27272B",
      "900": "#09090A"
    },
    "primary": {
      "100": "#def2ff",
      "200": "#b6e7ff",
      "300": "#75d5ff",
      "400": "#2cc1ff",
      "500": "#00a2ed",
      "600": "#0087d4",
      "700": "#006bab",
      "800": "#005a8d",
      "900": "#064b74"
    },
    "secondary": {
      "100": "#e6fded",
      "200": "#b3f9ca",
      "300": "#80f5a7",
      "400": "#4df083",
      "500": "#00ea4e",
      "600": "#00a437",
      "700": "#007527",
      "800": "#004617",
      "900": "#001708"
    },
    "success": {
      "100": "#CFFDD5",
      "200": "#A1FCB5",
      "300": "#70F69B",
      "400": "#4CED90",
      "500": "#16e280",
      "600": "#10C27E",
      "700": "#0BA278",
      "800": "#07836C",
      "900": "#02311c"
    },
    "warning": {
      "100": "#FEF9CB",
      "200": "#FEF198",
      "300": "#FEE765",
      "400": "#FDDE3F",
      "500": "#fdce00",
      "600": "#D9AC00",
      "700": "#B68D00",
      "800": "#926E00",
      "900": "#442404"
    },
    "danger": {
      "100": "#FEE9CD",
      "200": "#FECC9C",
      "300": "#FCA86A",
      "400": "#FA8645",
      "500": "#f74e09",
      "600": "#D43406",
      "700": "#B11F04",
      "800": "#8F0F02",
      "900": "#441006"
    }
  }
}
